import { store } from "./store/store";

import LoginComponent from "./components/auth/LoginComponent";
import ForgotPasswordComponent from "./components/auth/ForgotPasswordComponent";

/**** ADMIN COMPONENTS *****/
import AdminComponent from "./components/admin/AdminComponent";
import AdminDashboardComponent from "./components/admin/AdminDashboardComponent";
import AdminMockupsComponent from "./components/admin/AdminMockupsComponent";

//admin organizations
import AdminOrganizationComponent from "./components/admin/organization/AdminOrganizationComponent";
import AdminOrganizationListComponent from "./components/admin/organization/AdminOrganizationListComponent";
import AdminOrganizationCreateComponent from "./components/admin/organization/AdminOrganizationCreateComponent";
import AdminOrganizationDetailComponent from "./components/admin/organization/AdminOrganizationDetailComponent";
import AdminOrganizationEditComponent from "./components/admin/organization/AdminOrganizationEditComponent";
import AdminOrganizationImportProvidersComponent from "./components/admin/organization/AdminOrganizationImportProvidersComponent";
import AdminOrganizationImportsListComponent from "./components/admin/organization/imports/AdminOrganizationImportsListComponent";
import AdminOrganizationImportsDetailComponent from "./components/admin/organization/imports/AdminOrganizationImportsDetailComponent";

//admin providers
import AdminProviderComponent from "./components/admin/providers/AdminProviderComponent";
import AdminProviderListComponent from "./components/admin/providers/AdminProviderListComponent";
import AdminProviderDetailComponent from "./components/admin/providers/AdminProviderDetailComponent";
import AdminProviderCreateComponent from "./components/admin/providers/AdminProviderCreateComponent";
import AdminProviderEditComponent from "./components/admin/providers/AdminProviderEditComponent";
import AdminProviderImportComponent from "./components/admin/providers/AdminProviderImportComponent";
import AdminProviderOrganizationCourseDetail from "./components/admin/providers/AdminProviderOrganizationCourseDetail";

//admin smes
import AdminSMEComponent from "./components/admin/smes/AdminSMEComponent";
import AdminSMEListComponent from "./components/admin/smes/AdminSMEListComponent";
import AdminSMEDetailComponent from "./components/admin/smes/AdminSMEDetailComponent";
import AdminSMECreateComponent from "./components/admin/smes/AdminSMECreateComponent";
import AdminSMEEditComponent from "./components/admin/smes/AdminSMEEditComponent";

//admin categories
import AdminCategoryComponent from "./components/admin/categories/AdminCategoryComponent";
import AdminCategoryListComponent from "./components/admin/categories/AdminCategoryListComponent";
import AdminCategoryCreateComponent from "./components/admin/categories/AdminCategoryCreateComponent";
import AdminCategoryDetailComponent from "./components/admin/categories/AdminCategoryDetailComponent";
import AdminCategoryEditComponent from "./components/admin/categories/AdminCategoryEditComponent";

//admin courses
import AdminCourseComponent from "./components/admin/courses/AdminCourseComponent";
import AdminCourseListComponent from "./components/admin/courses/AdminCourseListComponent";
import AdminCourseCreateComponent from "./components/admin/courses/AdminCourseCreateComponent";
import AdminCourseEditComponent from "./components/admin/courses/AdminCourseEditComponent";
import AdminCourseDetailComponent from "./components/admin/courses/AdminCourseDetailComponent";

//admin config
import AdminConfigComponent from "./components/admin/configs/AdminConfigComponent";
import AdminEntityTaggableComponent from "./components/admin/configs/entities-taggables/AdminEntityTaggableComponent";
import AdminEntityTaggableListComponent from "./components/admin/configs/entities-taggables/AdminEntityTaggableListComponent";
import AdminEntityTaggableDetailComponent from "./components/admin/configs/entities-taggables/AdminEntityTaggableDetailComponent";

//admin notifications
import AdminNotificationManagementComponent from "./components/admin/notification_management/AdminNotificationManagementComponent";
import AdminNotificationManagementListComponent from "./components/admin/notification_management/AdminNotificationManagementListComponent";
import AdminNotificationManagementEditComponent from "./components/admin/notification_management/AdminNotificationManagementEditComponent";

//admin faqs
import AdminFAQComponent from "./components/admin/faqs/AdminFAQComponent";
import AdminFAQListComponent from "./components/admin/faqs/AdminFAQListComponent";
import AdminFAQCreateComponent from "./components/admin/faqs/AdminFAQCreateComponent";
import AdminFAQEditComponent from "./components/admin/faqs/AdminFAQEditComponent";

//admin terms
import AdminTermsComponent from "./components/admin/terms/AdminTermsComponent";
import AdminTermsListComponent from "./components/admin/terms/AdminTermsListComponent";
import AdminTermsCreateComponent from "./components/admin/terms/AdminTermsCreateComponent";
import AdminTermsEditComponent from "./components/admin/terms/AdminTermsEditComponent";

/**** ORGANIZATION COMPONENTS *****/
import OrganizationComponent from "./components/organizations/OrganizationComponent";
import OrganizationComponent1 from "./components/organizations/OrganizationComponent1";

//providers
import OrganizationDashboardComponent from "./components/organizations/OrganizationDashboardComponent";
import OrganizationProviderComponent from "./components/organizations/providers/OrganizationProviderComponent";
import OrganizationProviderListComponent from "./components/organizations/providers/OrganizationProviderListComponent";
import OrganizationProviderDetailComponent from "./components/organizations/providers/OrganizationProviderDetailComponent";
import OrganizationProviderCreateComponent from "./components/organizations/providers/OrganizationProviderCreateComponent";

//course components
import OrganizationCourseComponent from "./components/organizations/courses/OrganizationCourseComponent";
import OrganizationCourseListComponent from "./components/organizations/courses/OrganizationCourseListComponent";
import OrganizationCourseDetailComponent from "./components/organizations/courses/OrganizationCourseDetailComponent";
import OrganizationCourseDetailComponent2 from "./components/organizations/courses/OrganizationCourseDetailComponent2";
import OrganizationCourseSessionCreate from "./components/organizations/courses/OrganizationCourseSessionCreate";
import OrganizationCourseProviderDetailComponent from "./components/organizations/courses/providers/OrganizationCourseProviderDetailComponent";
import OrganizationCourseProviderMessageComponent from "./components/organizations/courses/providers/OrganizationCourseProviderMessageComponent";

//reports
import OrganizationReportComponent from "./components/organizations/reports/OrganizationReportComponent";
import OrganizationReportListComponent from "./components/organizations/reports/OrganizationReportListComponent";

/**** SME COMPONENTS ******/
import SMEComponent from "./components/sme/SMEComponent";
import SMEDashboardComponent from "./components/sme/SMEDashboardComponent";
import SMEMainView from "./components/sme/SMEMainView";

//course components
import SMECourseComponent from "./components/sme/courses/SMECourseComponent";
import SMECourseListComponent from "./components/sme/courses/SMECourseListComponent";
import SMECourseCreateComponent from "./components/sme/courses/SMECourseCreateComponent";
import SMEModuleCreate from "./components/sme/modules/SMEModuleCreate";
import SMEModuleView from "./components/sme/modules/SMEModuleView";
import SMECourseDetailComponent from "./components/sme/courses/SMECourseDetailComponent";
import SMECourseEditComponent from "./components/sme/courses/SMECourseEditComponent";
import SMECourseDuplicateComponent from "./components/sme/courses/SMECourseDuplicateComponent";

/* CSP Component */
import CustomerSuccessPanelMain from "./components/csp/CustomerSuccessPanelMain";
import CustomerSuccessProviderList from "./components/csp/CustomerSuccessProviderList";

/* Shopify */
import ShopifyMain from "./components/shopify/ShopifyMain";
import ShopifyModuleList from "./components/shopify/ShopifyModuleList";
import ShopifyDraftsandPrograms from "./components/shopify/ShopifyDraftsandPrograms";
import ShopifyCheckout from "./components/shopify/ShopifyCheckout";

/* SHARED */
//import ProfileComponent from './components/shared/ProfileComponent';
import ProfileEditComponent from "./components/shared/profile/ProfileEditComponent";
import sessionPlayerView from "./components/shared/sessionPlayerView";
import ServerErrorView from "./components/shared/ServerErrorView";


//router services
import provider_detail_service from './route.service';
const user_meta_actions = localStorage.getItem('meta_actions')

export const routes = [
  { path: "/", component: LoginComponent, name: "login" },
  {
    path: "/forgot-password",
    component: ForgotPasswordComponent,
    name: "forgot-password"
  },
  { path: "/profile", component: ProfileEditComponent, name: "profile" },
  { path: "/maintanence", component: ServerErrorView, name: "maintanence" },
  {
    path: "/admin",
    component: AdminComponent,
    children: [
      {
        path: "dashboard",
        component: AdminDashboardComponent,
        name: "admin.dashboard"
      },
      {
        path: "mockups",
        component: AdminMockupsComponent,
        name: "admin.mockups"
      },
      {
        path: "organizations",
        component: AdminOrganizationComponent,
        children: [
          {
            path: "",
            component: AdminOrganizationListComponent,
            name: "admin.organizations.index"
          },
          {
            path: "create",
            component: AdminOrganizationCreateComponent,
            name: "admin.organizations.create"
          },
          {
            path: ":id/detail",
            component: AdminOrganizationDetailComponent,
            name: "admin.organizations.detail"
          },
          {
            path: ":id/edit",
            component: AdminOrganizationEditComponent,
            name: "admin.organizations.edit"
          },
          {
            path: ":id/import",
            component: AdminOrganizationImportProvidersComponent,
            name: "admin.organizations.import"
          },
          {
            path: ":id/imports",
            component: AdminOrganizationImportsListComponent,
            name: "admin.organizations.imports.index"
          },
          {
            path: ":id/imports/:import_id",
            component: AdminOrganizationImportsDetailComponent,
            name: "admin.organizations.imports.detail"
          }
        ]
      },
      {
        path: "providers",
        component: AdminProviderComponent,
        children: [
          {
            path: "",
            component: AdminProviderListComponent,
            name: "admin.providers.index"
          },
          {
            path: "import",
            component: AdminProviderImportComponent,
            name: "admin.providers.import"
          },
          {
            path: "create",
            component: AdminProviderCreateComponent,
            name: "admin.providers.create"
          },
          {
            path: ":id/detail",
            component: AdminProviderDetailComponent,
            name: "admin.providers.detail",
          },
          {
            path: ":id/edit",
            component: AdminProviderEditComponent,
            name: "admin.providers.edit"
          },
          {
            path: ":id/organization/:organization_id/courses/:course_id",
            component: AdminProviderOrganizationCourseDetail,
            name: "admin.providers.organization.course"
          }
        ]
      },
      {
        path: "smes",
        component: AdminSMEComponent,
        children: [
          {
            path: "",
            component: AdminSMEListComponent,
            name: "admin.smes.index"
          },
          {
            path: "create",
            component: AdminSMECreateComponent,
            name: "admin.smes.create"
          },
          {
            path: ":id/detail",
            component: AdminSMEDetailComponent,
            name: "admin.smes.detail"
          },
          {
            path: ":id/edit",
            component: AdminSMEEditComponent,
            name: "admin.smes.edit"
          }
        ]
      },
      {
        path: "categories",
        component: AdminCategoryComponent,
        children: [
          {
            path: "",
            component: AdminCategoryListComponent,
            name: "admin.categories.index"
          },
          {
            path: "create",
            component: AdminCategoryCreateComponent,
            name: "admin.categories.create"
          },
          {
            path: ":id/detail",
            component: AdminCategoryDetailComponent,
            name: "admin.categories.detail"
          },
          {
            path: ":id/edit",
            component: AdminCategoryEditComponent,
            name: "admin.categories.edit"
          }
        ]
      },
      {
        path: "programs",
        component: AdminCourseComponent,
        children: [
          {
            path: "",
            component: AdminCourseListComponent,
            name: "admin.courses.index"
          },
          {
            path: "create",
            component: AdminCourseCreateComponent,
            name: "admin.courses.create"
          },
          {
            path: ":id/:section/:agency_id",
            component: OrganizationCourseDetailComponent2,
            name: "admin.courses.detail"
          },
          // {
          //   path: ":id/sessions/:agency_id",
          //   component: OrganizationCourseDetailComponent2,
          //   name: "admin.courses.detail"
          // },
           {
            path: ":id/detail/session-create/:agency_id",
            component: OrganizationCourseSessionCreate,
            name: "admin.courses.session"
          },
           {
            path: ":id/session-player/:session_id/:agency_id",
            component: sessionPlayerView,
            name: "admin.session.view"
          },
          {
            path: ":id/session-detail/:session_id/:agency_id",
            component: OrganizationCourseSessionCreate,
            name: "admin.courses.session_detail"
          },
          // {
          //   path: ":id/detail",
          //   //component: AdminCourseDetailComponent,
          //   component: OrganizationCourseDetailComponent2,
          //   name: "admin.courses.detail"
          // },
          {
            path: ":id/edit",
            component: AdminCourseEditComponent,
            name: "admin.courses.edit"
          }
        ]
      },
      {
        path: "configs",
        component: AdminConfigComponent,
        children: [
          {
            path: "tag-config",
            component: AdminEntityTaggableComponent,
            children: [
              {
                path: "",
                component: AdminEntityTaggableListComponent,
                name: "admin.configs.entities-taggables.index"
              },
              {
                path: ":id",
                component: AdminEntityTaggableDetailComponent,
                name: "admin.configs.entities.taggables.detail"
              }
            ]
          }
        ]
      },
      {
        path: "notifications-management",
        component: AdminNotificationManagementComponent,
        children: [
          {
            path: "",
            component: AdminNotificationManagementListComponent,
            name: "admin.notification-management.index"
          },
          {
            path: ":id/edit",
            component: AdminNotificationManagementEditComponent,
            name: "admin.notification-management.edit"
          }
        ]
      },
      {
        path: "faqs",
        component: AdminFAQComponent,
        children: [
          {
            path: "",
            component: AdminFAQListComponent,
            name: "admin.faq.index"
          },
          {
            path: "create",
            component: AdminFAQCreateComponent,
            name: "admin.faq.create"
          },
          {
            path: ":id/edit",
            component: AdminFAQEditComponent,
            name: "admin.faq.edit"
          }
        ]
      },
      {
        path: "terms",
        component: AdminTermsComponent,
        children: [
          {
            path: "",
            component: AdminTermsEditComponent,
            name: "admin.terms.index"
          }
        ]
      }
    ],
    beforeEnter: (to, from, next) => {
      //admin routes //organizations //providers //smes //categories //courses //configs
      if (store.getters.getRole == 0) {
        store
          .dispatch("checkAccessToken")
          .then(res => {
            // check for csm also for agency view
            if (
              store.getters.getRole == "admin" ||
              store.getters.getRole == "csm"
            ) {
              next();
            } else {
              window.location.href = "/".store.getters.getRole.charAt(0);
            }
          })
          .catch(error => {
            window.location.href = "/";
          });
      } else if (
        store.getters.getRole == "admin" ||
        store.getters.getRole == "csm"
      ) {
        next();
      }
    }
  },
  {
    path: "/o",
    component: OrganizationComponent1,
    children: [
      {
        path: "",
        component: OrganizationDashboardComponent,
        name: "organization.dashboard"
      },
      { path: "graficas", component: OrganizationComponent, name: "graficas" },
      {
        path: "providers",
        component: OrganizationProviderComponent,
        children: [
          {
            path: "",
            component: OrganizationProviderListComponent,
            name: "organization.providers.index"
          },
          {
            path: "create",
            component: OrganizationProviderCreateComponent,
            name: "organization.providers.create"
          },
          {
            path: ":id/detail",
            component: OrganizationProviderDetailComponent,
            name: "organization.providers.detail",
            beforeEnter: (to, from, next) => {
              provider_detail_service(next)
            }
          }
        ]
      },
      {
        path: "programs",
        component: OrganizationCourseComponent,
        children: [
          {
            path: "",
            component: OrganizationCourseListComponent,
            name: "organization.courses.index"
          },
          {
            path: ":id/:section",
            component: OrganizationCourseDetailComponent2,
            name: "organization.courses.detail"
          },
          {
            path: ":id/detail/session-create",
            component: OrganizationCourseSessionCreate,
            name: "organization.courses.session"
          },
          {
            path: ":id/session-player/:session_id",
            component: sessionPlayerView,
            name: "organization.session.view"
          },
          {
            path: ":id/sessions",
            component: OrganizationCourseDetailComponent2,
            name: "organization.courses.detail"
          },
          {
            path: ":id/session-detail/:session_id",
            component: OrganizationCourseSessionCreate,
            name: "organization.courses.session_detail"
          },
          {
            path: ":id/providers/:provider_id/messages",
            component: OrganizationCourseProviderMessageComponent,
            name: "organization.courses.providers.messages"
          },
          {
            path: ":id/providers/:provider_id/detail",
            component: OrganizationCourseProviderDetailComponent,
            name: "organization.courses.providers.detail"
          }
        ]
      },
      {
        path: "reports",
        component: OrganizationReportComponent,
        children: [
          {
            path: "",
            component: OrganizationReportListComponent,
            name: "organization.reports.index"
          }
        ]
      }
    ],
    beforeEnter: (to, from, next) => {
      //organization routes
      if (store.getters.getRole == 0) {
        store
          .dispatch("checkAccessToken")
          .then(res => {
            if (
              store.getters.getRole == "organization" ||
              store.getters.getRole == "csm"
            ) {
              next();
            } else {
              window.location.href = "/".store.getters.getRole.charAt(0);
            }
          })
          .catch(error => {
            window.location.href = "/";
          });
      } else if (store.getters.getRole == "organization") {
        next();
      }
    }
  },
  {
    path: "/s",
    component: SMEComponent,
    children: [
      //courses //sme routes
      // { path: "main", component: SMEMainView, name: "sme.main.view" },
      {
        path: "",
        component: SMECourseComponent,
        children: [
          {
            path: ":section",
            component: SMEMainView,
            name: "sme.dashboard",
          },
          {
            path: "create",
            component: SMECourseCreateComponent,
            name: "sme.courses.create"
          },
          {
            path: "create-module",
            component: SMEModuleCreate,
            name: "sme.module.create"
          },
          {
            path: ":id/module",
            component: SMEModuleView,
            name: "sme.module.view"
          },
          {
            path: ":id/detail",
            component: SMECourseDetailComponent,
            name: "sme.courses.detail"
          },
          {
            path: ":id/edit",
            component: SMECourseEditComponent,
            name: "sme.courses.edit"
          },
          {
            path: ":id/copy-log/:hash",
            component: SMECourseDuplicateComponent,
            name: "sme.courses.copy-log"
          }
        ]
      }
    ],
    beforeEnter: (to, from, next) => {
      //component: SMEMainView,
      if (store.getters.getRole == 0) {
        store
          .dispatch("checkAccessToken")
          .then(res => {
            if (store.getters.getRole == "sme") {
              next();
            } else {
              window.location.href = "/".store.getters.getRole.charAt(0);
            }
          })
          .catch(error => {
            window.location.href = "/";
          });
      } else if (store.getters.getRole == "sme") {
        next();
      }
    }
  },
  {
    path: "/csm",
    component: CustomerSuccessPanelMain,
    children: [
      {
        path: "",
        component: CustomerSuccessProviderList,
        name: "csm.dashboard"
      },
      {
        path: "agency",
        component: CustomerSuccessPanelMain,
        children: [
          
          {
            path: "",
            component: CustomerSuccessProviderList,
            name: "csm.providers.index"
          },
          {
            path: ":agency_id",
            component: CustomerSuccessProviderList,
            name: "csm.providers.list",
            children: [
              
              {
                path: "",
                component:AdminOrganizationDetailComponent,
                name: "csm.providers.info",
                props: {
                  AgencyView: true
                },
              }
            ],
          },
          {
            path: "provider/:id/detail",
            component: AdminProviderDetailComponent,
            name: "csm.providers.detail",
            beforeEnter: (to, from, next) => {
              if(user_meta_actions.includes('view_all_provider_details_including_roles')){
                next()
              }else{
                next({ name: 'Login' })
              }
            }
          },
          {
            path: "*",
            component: CustomerSuccessProviderList,
            name: "csm.providers.index"
          },
          {
            path: "create",
            component: OrganizationProviderCreateComponent,
            name: "csm.providers.create"
          }
        ]
      },
      {
        path: "plain_providers",
        component: AdminProviderListComponent,
        name: "csm.plain_providers"
      },
      {
        path: "organizations",
        component: AdminOrganizationComponent,
        children: [
          {
            path: "",
            component: AdminOrganizationListComponent,
            name: "csm.organizations.index"
          },
          {
            path: "create",
            component: AdminOrganizationCreateComponent,
            name: "csm.organizations.create"
          },
          {
            path: ":id/detail",
            component: AdminOrganizationDetailComponent,
            name: "csm.organizations.detail"
          },
          {
            path: ":id/imports",
            component: AdminOrganizationImportsListComponent,
            name: "csm.organizations.imports.index"
          },
          {
            path: ":id/imports/:import_id",
            component: AdminOrganizationImportsDetailComponent,
            name: "csm.organizations.imports.detail"
          },
          {
            path: "provider/:provider_id/courses/:id/detail",
            component: OrganizationCourseProviderDetailComponent,
            name: "csm.courses.providers.detail"
          }
        ]
      },
      {
        path: "programs",
        component: ShopifyMain,
        children: [
          {
            path: "",
            component: ShopifyDraftsandPrograms,
            name: "shopify.dashboard"
          },
          {
            path: ":id/module-list",
            component: ShopifyModuleList,
            name: "shopify.list"
          },
          {
            path: ":id/checkout",
            component: ShopifyCheckout,
            name: "shopify.checkout"
          }
        ]
      }
    ],
    beforeEnter: (to, from, next) => {
      if (store.getters.getRole == 0) {
        store
          .dispatch("checkAccessToken")
          .then(res => {
            if (
              store.getters.getRole == "csm" ||
              store.getters.getRole == "admin"
            ) {
              next();
            } else {
              window.location.href = "/".store.getters.getRole.charAt(0);
            }
          })
          .catch(error => {
            window.location.href = "/";
          });
      } else if (store.getters.getRole == "csm") {
        next();
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes.js